import React, { useState, useEffect } from "react";
import { Button, Form, Icon } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";
import "./OperadoresFormSimple.css";

const OperadoresFormSimple = ({
  accion,
  elementos,
  cerrarModal,
  idTransportista: idTransportistaProp,
  onSave
}) => {
  const [formulario, setFormulario] = useState({
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    contacto: "",
    vigenciaLicencia: "",
    tipoLicencia: ""
  });

  const [crudbutonEnable, setCrudbutonEnable] = useState(true);
  const [idTransportista, setIdTransportista] = useState(null);

  useEffect(() => {
    if (idTransportistaProp) {
      setIdTransportista(idTransportistaProp);
    }

    // Si es edición o vinculación con elementos, cargar datos
    if (elementos) {
      let fechaFormateada = "";
      if (elementos.licenciaVigencia) {
        const fecha = elementos.licenciaVigencia;
        if (typeof fecha === "number") {
          const d = new Date(fecha);
          fechaFormateada = d.toISOString().split("T")[0];
        } else {
          const fechaStr = String(fecha);
          if (fechaStr.includes("T")) {
            fechaFormateada = fechaStr.split("T")[0];
          } else if (fechaStr.match(/^\d{4}-\d{2}-\d{2}/)) {
            fechaFormateada = fechaStr.substring(0, 10);
          }
        }
      }

      // Si paterno y materno están vacíos pero el nombre contiene espacios, dividirlo
      // Desde el final: última=materno, penúltima=paterno, resto=nombre
      let nombreFinal = elementos.nombre || "";
      let paternoFinal = elementos.paterno || "";
      let maternoFinal = elementos.materno || "";

      if (!paternoFinal && !maternoFinal && nombreFinal.trim().includes(" ")) {
        const partes = nombreFinal.trim().split(/\s+/);
        if (partes.length >= 4) {
          maternoFinal = partes[partes.length - 1];
          paternoFinal = partes[partes.length - 2];
          nombreFinal = partes.slice(0, partes.length - 2).join(" ");
        } else if (partes.length === 3) {
          nombreFinal = partes[0];
          paternoFinal = partes[1];
          maternoFinal = partes[2];
        } else if (partes.length === 2) {
          nombreFinal = partes[0];
          paternoFinal = partes[1];
        }
      }

      setFormulario({
        nombre: nombreFinal,
        apellidoPaterno: paternoFinal,
        apellidoMaterno: maternoFinal,
        contacto: elementos.medioComunicacion || "",
        vigenciaLicencia: fechaFormateada,
        tipoLicencia: elementos.licenciaTipo || ""
      });
    }
  }, [accion, elementos]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setCrudbutonEnable(false);

    if (!idTransportista) {
      NotificationManager.error("No se pudo obtener el transportista.", "Error");
      setCrudbutonEnable(true);
      return;
    }

    const operadorDTO = {
      nombre: formulario.nombre.trim(),
      paterno: formulario.apellidoPaterno.trim(),
      materno: formulario.apellidoMaterno.trim(),
      medioComunicacion: formulario.contacto.trim(),
      licenciaTipo: formulario.tipoLicencia.trim(),
      licenciaVigencia: formulario.vigenciaLicencia
        ? new Date(formulario.vigenciaLicencia + "T12:00:00").getTime()
        : null,
      idTransportista: idTransportista
    };

    // Si es edición, incluir el id
    if (accion === "modificar" && elementos?.id) {
      operadorDTO.id = elementos.id;
    }

    // Buscar si ya existe un operador con ese nombre en el transportista
    if (accion === "nuevo") {
      try {
        const nombreBusqueda = `${operadorDTO.nombre} ${operadorDTO.paterno} ${operadorDTO.materno}`.trim().toUpperCase();
        const operadoresExistentes = await Crud_Catalogos(
          "operadores/transportista/" + idTransportista, "", "get", "", [], "", "", "", []
        );
        if (operadoresExistentes && Array.isArray(operadoresExistentes)) {
          const duplicado = operadoresExistentes.find(op => {
            const nombreOp = (op.nombreCompleto || `${op.nombre} ${op.paterno || ""} ${op.materno || ""}`.trim()).toUpperCase();
            return nombreOp === nombreBusqueda;
          });
          if (duplicado) {
            NotificationManager.info("Este operador ya existe en el catálogo, se vinculó correctamente", "Operador existente");
            if (onSave) {
              onSave({
                id: duplicado.id,
                nombre: duplicado.nombre,
                paterno: duplicado.paterno,
                materno: duplicado.materno,
                medioComunicacion: duplicado.medioComunicacion,
                licenciaTipo: duplicado.licenciaTipo,
                licenciaVigencia: duplicado.licenciaVigencia,
                nombreCompleto: duplicado.nombreCompleto || `${duplicado.nombre} ${duplicado.paterno || ""} ${duplicado.materno || ""}`.trim(),
              });
            }
            if (cerrarModal) cerrarModal();
            return;
          }
        }
      } catch (err) {
        console.error("Error al buscar operador existente:", err);
      }
    }

    const metodo = (accion === "modificar" && operadorDTO.id) ? "put" : "post";

    try {
      const response = await Crud_Catalogos("operadores", "", metodo, "", operadorDTO, "", "", "", []);
      if (response !== false && response) {
        NotificationManager.success(
          `Operador ${accion === "nuevo" ? "creado" : "actualizado"} exitosamente`,
          "Éxito"
        );
        if (onSave) {
          onSave({
            id: response.id || operadorDTO.id,
            nombre: operadorDTO.nombre,
            paterno: operadorDTO.paterno,
            materno: operadorDTO.materno,
            medioComunicacion: operadorDTO.medioComunicacion,
            licenciaTipo: operadorDTO.licenciaTipo,
            licenciaVigencia: operadorDTO.licenciaVigencia,
            nombreCompleto: `${operadorDTO.nombre} ${operadorDTO.paterno} ${operadorDTO.materno}`.trim(),
          });
        }
        if (cerrarModal) cerrarModal();
      } else {
        NotificationManager.error("Error al guardar el operador", "Error");
        setCrudbutonEnable(true);
      }
    } catch (err) {
      console.error("Error al guardar operador:", err);
      NotificationManager.error("Error al guardar el operador", "Error");
      setCrudbutonEnable(true);
    }
  };

  return (
    <div className="modern-operator-container">
      <div className="modern-header">
        <div className="header-content-modern">
          <div className="header-left-section">
            <div className="animated-icon">
              <Icon name="user" className="main-icon" />
            </div>
            <div className="header-text-section">
              <h1 className="modern-title">
                <span className="title-word">{accion === "nuevo" ? "NUEVO" : "EDITAR"}</span>
                <span className="title-word">OPERADOR</span>
              </h1>
            </div>
          </div>
        </div>
      </div>

      <Form onSubmit={handleSubmit} className="modern-form">
        <div className="section-card">
          <div className="section-header">
            <Icon name="user" className="section-icon" />
            <h4 className="section-title">INFORMACIÓN DEL OPERADOR</h4>
          </div>

          <div className="form-grid">
            <div className="form-field">
              <label className="field-label">
                <Icon name="user" className="field-icon" />
                Nombre
              </label>
              <div className="field-content">
                <Form.Input
                  className="modern-input"
                  name="nombre"
                  required
                  value={formulario.nombre}
                  onChange={(e) => setFormulario({ ...formulario, nombre: e.target.value })}
                  placeholder="Nombre(s)"
                />
              </div>
            </div>

            <div className="form-field">
              <label className="field-label">
                <Icon name="user" className="field-icon" />
                Apellido Paterno
              </label>
              <div className="field-content">
                <Form.Input
                  className="modern-input"
                  name="apellidoPaterno"
                  value={formulario.apellidoPaterno}
                  onChange={(e) => setFormulario({ ...formulario, apellidoPaterno: e.target.value })}
                  placeholder="Apellido paterno"
                />
              </div>
            </div>
          </div>

          <div className="form-grid">
            <div className="form-field">
              <label className="field-label">
                <Icon name="user" className="field-icon" />
                Apellido Materno
              </label>
              <div className="field-content">
                <Form.Input
                  className="modern-input"
                  name="apellidoMaterno"
                  value={formulario.apellidoMaterno}
                  onChange={(e) => setFormulario({ ...formulario, apellidoMaterno: e.target.value })}
                  placeholder="Apellido materno"
                />
              </div>
            </div>

            <div className="form-field">
              <label className="field-label">
                <Icon name="phone" className="field-icon" />
                Contacto
              </label>
              <div className="field-content">
                <Form.Input
                  className="modern-input"
                  name="contacto"
                  value={formulario.contacto}
                  onChange={(e) => setFormulario({ ...formulario, contacto: e.target.value })}
                  placeholder="Teléfono o email"
                />
              </div>
            </div>
          </div>

          <div className="form-grid">
            <div className="form-field">
              <label className="field-label">
                <Icon name="credit-card" className="field-icon" />
                Tipo de Licencia
              </label>
              <div className="field-content">
                <Form.Input
                  className="modern-input"
                  name="tipoLicencia"
                  value={formulario.tipoLicencia}
                  onChange={(e) => setFormulario({ ...formulario, tipoLicencia: e.target.value })}
                  placeholder="Ej: Federal"
                />
              </div>
            </div>

            <div className="form-field">
              <label className="field-label">
                <Icon name="calendar" className="field-icon" />
                Vigencia de Licencia
              </label>
              <div className="field-content">
                <Form.Input
                  type="date"
                  className="modern-input"
                  name="vigenciaLicencia"
                  value={formulario.vigenciaLicencia}
                  onChange={(e) => setFormulario({ ...formulario, vigenciaLicencia: e.target.value })}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <Button type="submit" color="primary" disabled={!crudbutonEnable}>
            <Icon name="save" /> {accion === "nuevo" ? "Registrar" : "Actualizar"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default OperadoresFormSimple;
